import ArticleReportsAPI from '../../api/articleReports';

// Define mutation types locally since they're not in the main mutation-types file
const types = {
  SET_ARTICLE_REPORTS: 'SET_ARTICLE_REPORTS',
  SET_BULK_ARTICLE_REPORTS: 'SET_BULK_ARTICLE_REPORTS', // Add this
  SET_ARTICLE_REPORTS_UI_FLAG: 'SET_ARTICLE_REPORTS_UI_FLAG',
};

const state = {
  reports: {},
  bulkReports: {}, // Add this
  uiFlags: {
    isFetching: false,
    isExporting: false,
  },
};

const getters = {
  getReports: $state => portalSlug => $state.reports[portalSlug] || {},
  getBulkReports: $state => $state.bulkReports, // Add this
  getUIFlags: $state => $state.uiFlags,
};

const actions = {
  async fetchReports({ commit }, { portalSlug, filters }) {
    commit(types.SET_ARTICLE_REPORTS_UI_FLAG, { 
      flag: 'isFetching', 
      value: true 
    });

    try {
      const response = await ArticleReportsAPI.getReports(portalSlug, filters);
      commit(types.SET_ARTICLE_REPORTS, {
        portalSlug,
        data: response.data,
      });
    } catch (error) {
      throw error;
    } finally {
      commit(types.SET_ARTICLE_REPORTS_UI_FLAG, { 
        flag: 'isFetching', 
        value: false 
      });
    }
  },

  // Add this new action
  async fetchBulkReports({ commit }, { portalSlugs, filters }) {
    commit(types.SET_ARTICLE_REPORTS_UI_FLAG, { 
      flag: 'isFetching', 
      value: true 
    });

    try {
      const response = await ArticleReportsAPI.getBulkReports(portalSlugs, filters);
      commit(types.SET_BULK_ARTICLE_REPORTS, {
        data: response.data,
      });
    } catch (error) {
      throw error;
    } finally {
      commit(types.SET_ARTICLE_REPORTS_UI_FLAG, { 
        flag: 'isFetching', 
        value: false 
      });
    }
  },

  async exportReports({ commit }, { portalSlugs, filters, format = 'csv' }) {
    commit(types.SET_ARTICLE_REPORTS_UI_FLAG, { 
      flag: 'isExporting', 
      value: true 
    });

    try {
      const response = await ArticleReportsAPI.exportReports(portalSlugs, filters, format);
      
      // Generate filename based on selection and format
      let filename;
      const timestamp = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
      const extension = format === 'csv' ? 'csv' : 'xlsx';
      
      if (Array.isArray(portalSlugs) && portalSlugs.length > 1) {
        filename = `article-reports-multiple-portals-${timestamp}.${extension}`;
      } else {
        const portalSlug = Array.isArray(portalSlugs) ? portalSlugs[0] : portalSlugs;
        filename = `article-reports-${portalSlug}-${timestamp}.${extension}`;
      }
      
      // Create download link
      const mimeType = format === 'csv' 
        ? 'text/csv;charset=utf-8;' 
        : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        
      const url = window.URL.createObjectURL(new Blob([response.data], { type: mimeType }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      throw error;
    } finally {
      commit(types.SET_ARTICLE_REPORTS_UI_FLAG, { 
        flag: 'isExporting', 
        value: false 
      });
    }
  },
};

const mutations = {
  [types.SET_ARTICLE_REPORTS]($state, { portalSlug, data }) {
    $state.reports = {
      ...$state.reports,
      [portalSlug]: data,
    };
  },

  // Add this new mutation
  [types.SET_BULK_ARTICLE_REPORTS]($state, { data }) {
    $state.bulkReports = data;
  },

  [types.SET_ARTICLE_REPORTS_UI_FLAG]($state, { flag, value }) {
    $state.uiFlags = {
      ...$state.uiFlags,
      [flag]: value,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
